class SecondaryNav extends HTMLElement {
  constructor() {
    super();
    this.scheduledOpening = undefined;
    this.openedMenu = undefined;
  }

  connectedCallback() {
    this.getAllMenus().forEach((menu) => {
      menu.addEventListener('mouseenter', this.openMenu);
      menu.addEventListener('mousemove', this.openMenu);

      const overlay = menu.querySelector('.modal-overlay');
      overlay.style.height = `${document.body.scrollHeight}px`;
      overlay.addEventListener('mouseenter', this.closeAllMenus);
    });

    this.addEventListener('mouseleave', this.closeAllMenus);
  }

  disconnectedCallback() {
    this.getAllMenus().forEach((menu) => {
      menu.removeEventListener('mouseenter', this.openMenu);
      menu.removeEventListener('mousemove', this.openMenu);

      const overlay = menu.querySelector('.modal-overlay');
      overlay.removeEventListener('mouseenter', this.closeAllMenus);
    });

    this.removeEventListener('mouseleave', this.closeAllMenus);
  }

  getAllMenus() {
    return Array.from(this.querySelectorAll('.mega-menu'));
  }

  openMenu = (e) => {
    const menuToOpen = e.currentTarget;
    if (this.scheduledOpening) {
      clearTimeout(this.scheduledOpening);
    }

    const setMenuStates = () => {
      menuToOpen.setAttribute('open', true);
      this.getAllMenus()
        .filter((menu) => menu !== menuToOpen)
        .forEach((otherMenu) => {
          otherMenu.removeAttribute('open');
        });
      this.openedMenu = menuToOpen;
    };

    if (this.openedMenu) {
      setMenuStates();
    } else {
      this.scheduledOpening = setTimeout(setMenuStates, 100);
    }
  };

  closeAllMenus = () => {
    if (this.scheduledOpening) {
      clearTimeout(this.scheduledOpening);
    }

    this.getAllMenus().forEach((menu) => {
      menu.removeAttribute('open');
    });
    this.openedMenu = undefined;
  };
}

if (!customElements.get('secondary-nav')) {
  customElements.define('secondary-nav', SecondaryNav);
}
